import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import * as DeviceDetector from "device-detector-js";

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'

})
export class UtilService {

  constructor(
    public http: HttpClient
  ) {
  }

  getDeviceInfo() {
    const userAgent = navigator.userAgent;
    const deviceDetector = new DeviceDetector();
    const { device } = deviceDetector.parse(userAgent);
    return device;
  }

  getCurrentLocation() {
    const currentLocationPromise = new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const location = {
          status: true,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        resolve(location);
      });
    });
    return currentLocationPromise;
  }

  async getPublicIpAddress() {
      const address = await this.http.get(environment.GET_PUBLIC_IP_URL).toPromise();
      return address || { ip: '' };
  }

  async getDeviceDetails() {
    const device = this.getDeviceInfo();
    const ipAddresses = await this.getPublicIpAddress();
    const location = await this.getCurrentLocation();
    return {
      ipAddresses,
      device,
      location
    }
  }

  async getDeviceDetailProp() {
    const device = this.getDeviceInfo();
    const ipAddresses = await this.getPublicIpAddress();
    const location: any = await this.getCurrentLocation();
    
    return {
      deviceType: device.type,
      deviceBrand: device.brand,
      deviceModel: device.model,
      ipAddress: ipAddresses['ip'],
      latitude: location['latitude'],
      longitude: location['longitude']
    };
  }

  async getCurrentPosition(component) {
    let oCurrent = this;
    let oThat = component;
    const options = {
      enableHighAccuracy: false,
      timeout: 60000,
      maximumAge: 0
    };

    async function success(pos) {
      let crd = await oCurrent.getDeviceDetailProp();
      oThat.crd = { "status": true, "data" : crd };
    }

    function error(err) {
      oThat.crd = { "status": false, "message": err.message + ", Please enable device location to procced further." };
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  }

}

export default UtilService;
